import { useStanQuery } from '.';
import { useMemo } from 'react';
import { debounce } from 'lodash';
import { QUERY_KEYS } from '@/lib/constants';
import { fetchBalance } from '@/lib/api/income/api';

export function useBalance() {
    const {
        data: balance,
        isLoading: isBalanceLoading,
        error: balanceError,
        refetch,
    } = useStanQuery({
        queryKey: [QUERY_KEYS.BALANCE],
        queryFn: fetchBalance,
        staleTime: 1000 * 60 * 5, // TODO: do we need this?
        meta: { error: { sentryMessage: '[BALANCE] failed-to-fetch-balance' } },
    });
    const refetchBalance = useMemo(() => debounce(refetch, 300), [refetch]);

    return { balance, isBalanceLoading, balanceError, refetchBalance };
}
